// src/components/tip/WalletDashboard.js

import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../platform/components/auth/auth-context';
import WalletDashboardInner from './walletDashboardInner';
import { useSelectedBusiness } from '../../../../platform/redux/store';
// Guard wrapper
export default function WalletDashboard() {
  const { staffUrl } = useParams();
  const navigate = useNavigate();
  const { providerUser } = useContext(UserContext);
  const selectedBusiness = useSelectedBusiness();

  useEffect(() => {
    // 1) Not logged in → send to login
    if (!providerUser?.userId) {
      navigate('/login');
    }
    // 2) URL mismatch → send to your own wallet
    else if (providerUser.url !== staffUrl) {
      const myBizSlug = selectedBusiness?.businessBasic?.url;
      navigate(`/${myBizSlug}/${providerUser.url}/wallet`);
    }
  }, [providerUser, staffUrl, selectedBusiness, navigate]);

  // Don’t render the inner component until checks pass
  if (!providerUser || providerUser.url !== staffUrl) {
    return null;
  }

  // All clear → render the real dashboard
  return <WalletDashboardInner />;
}
